import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PmOfferContractTypesState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: PmOfferContractTypesState = {
  data: [],
  isLoading: false,
  error: null,
};

const PmOfferContractTypesSlice = createSlice({
  name: 'pmOfferContractTypes',
  initialState,
  reducers: {
    setPmOfferContractTypes: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setPmOfferContractTypesLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setPmOfferContractTypesError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setPmOfferContractTypes, setPmOfferContractTypesLoading, setPmOfferContractTypesError } =
  PmOfferContractTypesSlice.actions;

export default PmOfferContractTypesSlice.reducer;
